// removed by extract-text-webpack-plugin
module.exports = {"nf-tooling-def-form":"nf-tooling-def-form","nf-user-form":"nf-user-form","nf-user-form__button":"nf-user-form__button","nf-user-form__label-input-pair":"nf-user-form__label-input-pair","nf-user-form__label":"nf-user-form__label","nf-user-form__required":"nf-user-form__required","nf-user-form__error":"nf-user-form__error","nf-button":"nf-button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/UserForm/UserForm.scss
// module id = 5354
// module chunks = 1